exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.blog-title[data-v-487195dc] {\n  font-size: 45px;\n  font-family: Roboto Condensed, sans-serif;\n}\n@media (max-width: 576px) {\n.blog-title[data-v-487195dc] {\n    font-size: 32px;\n}\nh2.post-title[data-v-487195dc] {\n    line-height: 1.4;\n    margin-bottom: 18px;\n}\n}\n", ""]);

// exports
